import { useState, useEffect, useContext, useRef, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { GlobalContext } from '../context/global.context'
import useGeneralApi from '../apis/useGeneralApi'
import useDetailsApi from '../apis/useDetailsApi'
import { routeMap } from '../route'
import utils from '../utils/utils'
import { splitLanguage } from '../utils/localStorageService'
import useFirebaseTrace from '../hooks/useFirebaseTrace'

// import { useWhatChanged } from '@simbathesailor/use-what-changed';
// USAGE: useWhatChanged([a, b, c, d], 'a, b, c, d'); // debugs the below useEffect

/** Custom hook for to handle catalog rail */
const useCatalog = ({ sysId, query, pageType, pageName, isThisCREATE, mediaId }) => {
  const firebaseTrace = useFirebaseTrace()
  const { getRailInfo, getChannelInfo } = useGeneralApi()
  const { getChannelPrograms } = useDetailsApi()
  const [railInfo, updateRailInfo] = useState({})
  const [railItemsInfo, updateRailItemsInfo] = useState(getPlaceholders())
  const [isNoData, setIsNoData] = useState(false)
  const { appLanguage, dispatch } = useContext(GlobalContext)
  const isScrollPaginationRef = useRef(false)
  const { pageComponent = {} } = useSelector(store => store.navigation)
  const { appConfig } = useSelector(store => store.appConfigReducers)
  const { pageComponents = {} } = pageComponent
  const pComponent = pageComponents[sysId]
  const pComponentRef = useRef({})
  const totalPageRef = useRef(1)
  const railItemsInfoRef = useRef(railItemsInfo)
  const apiInProgresss = useRef(false)

  /** Fetches catalog data */
  const fetchCatalog = useCallback((fnParams) => {
    let {
      currentPageNumber = 1, railItems = [], maxItems = null,
      baseUrl = '', appLanguage = '',
      config, pageType
    } = fnParams || {}

    if (currentPageNumber > (totalPageRef.current || 1) || (maxItems !== null && railItems.length > maxItems)) {
      return Promise.resolve(railItems)
    }

    dispatch({ type: 'IS_RAIL_ITEMS_LOADING', value: true})

    const { identifierExt = '', curatedData = [] } = config || {}
    let type = (config || {}).type

    let params = {
      page: currentPageNumber,
      language: splitLanguage(appLanguage),
      size: config.apiPageSize || 50
    }

    if (config.params) {
      let _params = config.params || ''
      _params = _params.replace(/,/g, '&')
      _params = utils.parse(_params)
      params = { ...params, ..._params }
    }

    let api = null
    let data = (config || {}).data

    if (identifierExt === 'related') {
      // Do nothing, this is for recombee recommendation, hence it will be handled by useRecommendation.
    } else if (type === 'other' && pageType !== 'listing') {
      const items = curatedData.map((props) => {
        const { data = '', graphics = [] } = props
        let images = []
        if (utils.isNotNull(graphics, 0, 'images')) {
          images = graphics[0].images
        }
        return { ...props, uid: data, images, isCuratedData: true }
      })
      return Promise.resolve(items)
    } else if (identifierExt === 'channels') {
      const functionToGetData = () => {
        // if (isThisCREATE) return getChannelPrograms(appConfig.baseUrl, 1598121000000, 1598207399999)
        const fromTime = new Date().getTime() - 5 * 60 * 60 * 1000 // 5 hours before from Now
        const toTime = new Date().getTime() + 5 * 60 * 60 * 1000 // 5 Hours after today
        if (isThisCREATE) return getChannelPrograms(appConfig.baseUrl, fromTime, toTime)
        else return getChannelInfo(appConfig.baseUrl, data, params)
      }
      const getFormattedTime = time => {
        return `${('0' + new Date(time).getHours()).slice(-2)}:${('0' + new Date(time).getMinutes()).slice(-2)}`
      }
      api = functionToGetData().then((res = {}) => {
        if (isThisCREATE) {
          const content = res.entries.map((channel) => {
            // console.log('Rest Entries', entry.stations[0].thumbnails[0].url)
            const key = Object.keys(channel.stations)[0]
            const logoKey = Object.keys(channel.stations[key].thumbnails)[0]
            // console.log('Rest Entries', entry.stations[key].thumbnails[logoKey].url)
            // here we have channels in channel
            // let channelName = channel.guid
            const currentLocalTime = new Date().getTime()
            const programsStartingBeforeCurrentLocalTime = channel && channel.listings && channel.listings.filter(program => program.startTime < currentLocalTime)
            const programStartingAfterCurrentLocalTime = channel && channel.listings && channel.listings.filter(program => program.startTime > currentLocalTime)
            let programRunningNow = programsStartingBeforeCurrentLocalTime.filter(program => program.startTime < currentLocalTime && program.endTime > currentLocalTime)[0] || null
            // console.log('program arrays', programsStartingBeforeCurrentLocalTime, programStartingAfterCurrentLocalTime)
            // const programRunningNow = programsStartingBeforeCurrentLocalTime[programsStartingBeforeCurrentLocalTime.length - 1]
            const programRunningNext = programStartingAfterCurrentLocalTime && programStartingAfterCurrentLocalTime[0]
            let isAllDataAvailable = true
            let nowProgramDetails = {}
            let nextProgramDetails = {}
            if (!programRunningNow || programRunningNow === []) {
              isAllDataAvailable = false
              nowProgramDetails = {
                title: '',
                time: ''
              }
              nextProgramDetails = {
                title: '',
                time: ''
              }
              programRunningNow = {
                startTime: 0,
                endTime: 0
              }
            } else {
              nowProgramDetails = {
                title: programRunningNow && programRunningNow.program && programRunningNow.program.title ? programRunningNow.program.title : '',
                time: `${getFormattedTime(programRunningNow && programRunningNow.startTime ? programRunningNow.startTime : 0)} - ${getFormattedTime(programRunningNow && programRunningNow.endTime ? programRunningNow.endTime : 0)}` || ''
              }
              nextProgramDetails = {
                title: programRunningNext && programRunningNext.program && programRunningNext.program.title ? programRunningNext.program.title : '',
                time: `${getFormattedTime(programRunningNext && programRunningNext.startTime ? programRunningNext.startTime : 0)} - ${getFormattedTime(programRunningNext && programRunningNext.endTime ? programRunningNext.endTime : 0)}` || ''
              }
            }

            return {
              // title: channel.title,
              // logo: 'https://pmd205470tn-a.akamaihd.net/D2C_Partner_-_Diagnal_Sales_Demo_(ERA_3.0)/477/945/SixxAT__347030.png',
              logo: channel.stations[key].thumbnails[logoKey].url || '',
              type: 'channel',
              uid: channel.guid,
              channelNumber: Math.floor(Math.random() * (999 - 100 + 1) + 100),
              nowProgramDetails: nowProgramDetails,
              nextProgramDetails: nextProgramDetails,
              isShowRailItemInfo: true,
              duration: programRunningNow && programRunningNow.endTime && programRunningNow && programRunningNow.startTime ? programRunningNow.endTime - programRunningNow.startTime : 0,
              progress: programRunningNow && programRunningNow.startTime ? currentLocalTime - programRunningNow.startTime : 0,
              isAllDataAvailable: isAllDataAvailable,

              images: [
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'landscape',
                  width: 1920,
                  height: 1080
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'portrait',
                  width: 1280,
                  height: 1920
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'portrait',
                  width: 1000,
                  height: 1500
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'portrait',
                  width: 800,
                  height: 1200
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'portrait',
                  width: 500,
                  height: 750
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'portrait',
                  width: 200,
                  height: 300
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'landscape',
                  width: 240,
                  height: 135
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'landscape',
                  width: 320,
                  height: 180
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'landscape',
                  width: 640,
                  height: 360
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'landscape',
                  width: 1280,
                  height: 720
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'square',
                  width: 1080,
                  height: 1080
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'square',
                  width: 640,
                  height: 640
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'square',
                  width: 360,
                  height: 360
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'landscape',
                  width: 1440,
                  height: 1080
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'landscape',
                  width: 700,
                  height: 525
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'landscape',
                  width: 300,
                  height: 225
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'landscape',
                  width: 1500,
                  height: 570
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'landscape',
                  width: 700,
                  height: 226
                },
                {
                  url: channel.stations[key].thumbnails[logoKey].url || '',
                  type: 'landscape',
                  width: 480,
                  height: 182
                }
              ]
            }
          }
          )

          res = {}
          res.content = content
          return res
        }
      })
    } else if (!mediaId) {
      const hasQueryString = (data || '').split('?').length > 1
      const dataParm = (data || '').split('?')[0]
      if (hasQueryString) {
        const dataQueryStringInJSON = utils.parse(data || '') || {}
        params = { ...params, ...dataQueryStringInJSON }
      }
      params = utils.stringify(params)
      api = getRailInfo(baseUrl, dataParm, params)
    }


    if (api) {
      return api.then((res = {}) => {
        res = res || {}
        totalPageRef.current = (res.totalPages || 1)
        if (res.content) {
          const content = res.content || []
          railItems = [...railItems, ...content]
        }
        return Promise.resolve(railItems)
      })
    } else {
      return Promise.resolve(railItems)
    }
  }, [appConfig.baseUrl, getRailInfo, getChannelInfo, getChannelPrograms, isThisCREATE, mediaId, dispatch])

  useEffect(() => {
    pComponentRef.current = pComponent
  }, [pComponent])

  useEffect(() => {
    railItemsInfoRef.current = railItemsInfo
  }, [railItemsInfo])

  useEffect(() => {
    /**
     * Process rail configuration.
     */
    const _query = utils.parse(query)
    if (pageType === 'search') return
    if (pageType === 'favorites') return
    if (_query.fromPage === 'search') return
    if (!appConfig.baseUrl) return
    if (!pComponentRef.current) return
    if (!sysId) return

    const { config = {}, componentStyle = [], theme = {} } = pComponentRef.current || {}
    const { data, params, identifierExt } = config || {}
    const maxItems = _query.viewall ? null : (config || {}).maxItems
    let { title = '' } = config || {}

    let type = (config || {}).type
    if (_query.viewall) type = 'listingParams'

    if (identifierExt === 'recentlyWatched') return
    if (pageType === 'listing' || type === 'listingParams') return

    let style = componentStyle.map((style) => {
      return { ...style }
    })
    if (style.length > 0 && pageType === 'listing') {
      style = style.map((style) => {
        style.type = 'grid'
        if (!_query.viewall) {
          style.showComponentTitle = true
          style.showItemTitle = true
          style.itemSize = 'medium'
          style.itemEdgeRadius = 0.25
          style.itemOrientation = 0.667
        }
        if (style.itemOrientation) {
          if (style.itemOrientation > 1) {
            style.maxItemTitleLines = 2 // landscape
          } else {
            style.maxItemTitleLines = 3 // portrait
          }
        }
        return { ...style }
      })
    }
    isScrollPaginationRef.current = isScrollPaginate(style)
    const viewAllLink = `${routeMap.listing}?sysId=${sysId}&viewall=true`
    updateRailInfo({
      ...config,
      title,
      data,
      identifierExt,
      params,
      type,
      maxItems,
      style,
      viewAllLink,
      sysId,
      isRailItemPlayBtn: (identifierExt === 'channels'),
      componentTheme: theme,
      favouritesPage: false
    })
    updateRailItemsInfo(getPlaceholders())
  }, [
    appConfig.baseUrl,
    pageType,
    query,
    sysId,
    isThisCREATE
  ])

  useEffect(() => {
    /**
     * Fetch and update rail data.
     */
    let isMounted = true
    const _query = utils.parse(query)
    if (pageType === 'search') return
    if (pageType === 'favorites') return
    if (_query.fromPage === 'search') return
    if (!appConfig.baseUrl) return
    if (!pComponentRef.current) return
    if (!sysId) return

    const { config = {} } = pComponentRef.current || {}
    const { identifierExt, data } = config || {}
    const maxItems = _query.viewall ? null : (config || {}).maxItems
    let currentPageNumber = 0
    let timer = null

    let type = (config || {}).type
    if (_query.viewall) type = 'listingParams'

    if (identifierExt === 'recentlyWatched') return
    if (pageType === 'listing' || type === 'listingParams') return

    const onScroll = () => {
      if (apiInProgresss.current) return // do not call another api when one already in progress

      let trace = null

      if (type === 'other' && pageType !== 'listing') {
      } else if (identifierExt === 'channels') {
        if (!data) {
          updateRailItemsInfo([])
          setIsNoData(true)
          return
        }
      } else if (!mediaId) {
        if (!data) {
          updateRailItemsInfo([])
          setIsNoData(true)
          return
        }
      }

      trace = firebaseTrace(pageName + '_carousel_load', {
        carouselId: config.identifierExt || 'catalog'
      })

      apiInProgresss.current = true
      currentPageNumber = currentPageNumber + 1
      fetchCatalog({
        currentPageNumber,
        railItems: railItemsInfoRef.current || [],
        maxItems,
        config,
        baseUrl: appConfig.baseUrl,
        appLanguage,
        _query,
        pageType
      }).then((railItemData = []) => {
        if (!isMounted) return
        railItemData = railItemData
          .filter(Boolean)
          .filter(item => !item.isPlaceholder)

        if (railItemData.length === 0) {
          updateRailItemsInfo([])
          setIsNoData(true)
        } else {
          updateRailItemsInfo(railItemData)
        }

        if (trace) {
          trace.stop()
          trace = null
        }
        apiInProgresss.current = false
      }).catch((error) => {
        if (!isMounted) return
        console.error('ERROR: Catalog', error)
        updateRailItemsInfo([])
        setIsNoData(true)
        if (trace) {
          trace.stop()
          trace = null
        }
        apiInProgresss.current = false
      }).finally(() => {
        dispatch({ type: 'IS_RAIL_ITEMS_LOADING', value: false})
      })
    }

    updateRailInfo(railInfo => ({ ...railInfo, onScroll }))
    onScroll()

    return () => {
      isMounted = false
      clearTimeout(timer)
    }
  }, [
    appConfig.baseUrl,
    appLanguage,
    fetchCatalog,
    mediaId,
    pageName,
    pageType,
    query,
    sysId,
    firebaseTrace,
    dispatch
  ])

  return { railInfo, railItemsInfo, isNoData }
}

const getPlaceholders = () => {
  /**
   * @return Rail placeholders data.
   */
  const items = []
  for (let i = 0; i < 3; i++) items.push({ isPlaceholder: true })
  return items
}

const isScrollPaginate = (style) => {
  /**
   * @return type of scroll.
   */
  return !(utils.isNotNull(style, 0, 'type') && style[0].type === 'grid')
}

export default useCatalog
